
import router from '../router'

/**
 * Resolves any route options.
 * @param {*} routeOptions 
 * @returns {string}
 */
export const openRouteInNewTab = (routeOptions) => {
    if(!routeOptions) throw new Error("Please, provide route options.");

    const href = router.resolve(routeOptions).href;

    if(href){
        window.open(href, '_blank');
    }

    return href;
}

/**
 * Rounds the given weight (kg) based on specific rules.
 * @param {number} kg - The weight in kilograms to be rounded.
 * @returns {number} - The rounded weight.
 */
export const roundWeight = (kg) => {
    if (kg < 10) {
        const decimalPart = kg % 1;
        if (decimalPart <= 0.5) {
            return Math.floor(kg) + (decimalPart > 0 ? 0.5 : 0);
        } else {
            return Math.ceil(kg);
        }
    } else {
        return Math.ceil(kg);
    }
};

/**
 * Calculates the chargeable weight based on the dimensions of the container and the number of containers.
 * The formula used is: (width * length * height) / 5000, rounded using specific rules, and multiplied by the container count.
 *
 * @param {number} width - The width of the container in centimeters.
 * @param {number} length - The length of the container in centimeters.
 * @param {number} height - The height of the container in centimeters.
 * @param {number} containerCount - The number of containers.
 * @returns {number} - The calculated chargeable weight.
 */
export const calculateChargeableWeight = (width, length, height, containerCount) => {
    return roundWeight((width * length * height) / 5000) * containerCount;
};

export const getSpecialRulesForPostalCode = (countryList = [], selectedCountryId = null) => {
    if(countryList.length === 0 || !selectedCountryId) return null;

     const country = countryList.find(i => i?.Id === selectedCountryId)

      if(country?.ISOCode2 === "US" || country?.ISOCode3 === "USA"){
        return {
          max: 5,
          min: 5
        }
      }

      return null;
}